import { css } from '@emotion/react';

export const row = css({ display: 'flex', alignItems: 'center' });
export const column = css({
	display: 'flex',
	flexDirection: 'column'
});




